import styled from 'styled-components';

import musd from '@/shared/assets/musd.webp';
import cbbtcIcon from '@/shared/assets/cbbtc.webp';
import bobIcon from '@/shared/assets/bob-token.png';
import ohmIcon from '@/shared/assets/ohm-token.png';
import wglmrIcon from '@/shared/assets/wglmrIcon.png';
import axlIcon from '@/shared/assets/axl-token.png';
import rethIcon from '@/shared/assets/reth-token.png';
import ghoIcon from '@/shared/assets/gho-token.png';
import cbethIcon from '@/shared/assets/cbeth-token.png';
import lrethIcon from '@/shared/assets/icons/lrteth.svg';
import pondIcon from '@/shared/assets/icons/marlin-pond.svg';
import ibtcIcon from '@/shared/components/LrtIcon/iBTCIcon.png';
import unibtcIcon from '@/shared/components/LrtIcon/uniBTCIcon.svg';
import wstUSRIcon from '@/shared/components/LrtIcon/wstUSRIcon.svg';
import usbdIcon from '@/shared/assets/icons/usbd.svg';
import ssvIcon from '@/shared/assets/ssv-network.svg';
import sisIcon from '@/shared/assets/sis.png';
import mBtcIcon from '@/shared/assets/m-btc.jpg';
import lskIcon from '@/shared/assets/lsk.webp';
import liskRewardIcon from '@/shared/assets/lisk_reward.svg';
import syusdIcon from '@/shared/assets/icons/syusd.svg';
import fraxIcon from '@/shared/assets/icons/frax.svg';
import cycIcon from '@/shared/assets/icons/cyc.png';
import bardIcon from '@/shared/assets/icons/bard.svg';
import usdcIcon from '@/shared/assets/icons/usdc.svg';
import usdtIcon from '@/shared/assets/icons/usdt.svg';
import kaitoIcon from '@/shared/assets/icons/kaito.jpg';
import usdsIcon from '@/shared/assets/icons/usds.webp';
import solvIcon from '@/shared/assets/icons/solv.svg';
import monIcon from '@/shared/assets/icons/mon.svg';
import musdIcon from '@/shared/assets/icons/musd.svg';
import thqIcon from '@/shared/assets/icons/thq.svg';
import rbtcIcon from '@/shared/assets/icons/RBTC.svg';
import btcIcon from '@/shared/assets/btc.svg';

import { SpriteIcon } from '../SpriteIcon';

type Props = {
  className?: string;
  dense?: boolean;
  icons: string[];
  size?: number;
  indent?: boolean;
};

const CLASS_NAME = 'TOKEN_ICON';

const StyledIconList = styled.div`
  display: inline-flex;

  .${CLASS_NAME} {
    margin-right: ${({ $dense, size }: { $dense: boolean; size: number }) =>
      $dense ? `-${size / 4}rem` : `-${size / 4}rem`};
  }

  padding-right: ${({ $indent }: { $indent: boolean }) => ($indent ? '5px' : 0)};
`;

export const pngIcons: Record<string, string> = {
  BOB: bobIcon,
  OHM: ohmIcon,
  WGLMR: wglmrIcon,
  AXL: axlIcon,
  rETH: rethIcon,
  GHO: ghoIcon,
  cbETH: cbethIcon,
  lrteth: lrethIcon,
  IBTC: ibtcIcon,
  uniBTC: unibtcIcon,
  POND: pondIcon,
  wstUSR: wstUSRIcon,
  USBD: usbdIcon,
  SSV: ssvIcon,
  SIS: sisIcon,
  mBTC: mBtcIcon,
  LSK: lskIcon,
  LiskReward: liskRewardIcon,
  sYUSD: syusdIcon,
  FRAX: fraxIcon,
  CYC: cycIcon,
  BARD: bardIcon,
  USDC: usdcIcon,
  USDT: usdtIcon,
  KAITO: kaitoIcon,
  USDS: usdsIcon,
  SOLV: solvIcon,
  MON: monIcon,
  WMON: monIcon,
  MUSD: musdIcon,
  THQ: thqIcon,
  cbBTC: cbbtcIcon,
  mUSD: musd,
  RBTC: rbtcIcon,
  BTC: btcIcon,
};

export const IconList: React.VFC<Props> = ({
  className = '',
  dense = false,
  icons,
  size = 3.2,
  indent,
}) => (
  <StyledIconList className={className} $dense={dense} size={size} $indent={indent}>
    {icons.map((icon, index) => {
      if (pngIcons[icon]) {
        return (
          <img
            key={icon}
            src={pngIcons[icon]}
            width={`${size * 10}px`}
            height={`${size * 10}px`}
            alt={`${icon} icon`}
            className={index !== icons.length ? CLASS_NAME : undefined}
            style={{ zIndex: 10 - index }}
          />
        );
      }

      return (
        <span
          className={index !== icons.length ? CLASS_NAME : undefined}
          style={{
            zIndex: 10 - index,
            display: 'flex',
            alignItems: 'center',
            height: 'min-content',
          }}
          key={icon}
        >
          <SpriteIcon icon={icon} size={size} />
        </span>
      );
    })}
  </StyledIconList>
);
